export enum TaskLogStatus {
  none = 0,
  succeeded = 1,
  canceled = 2,
  failed = 3,
  running = 4
}
